module.exports = __webpack_public_path__ + "static/img/29.6dd7d52.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fifa2026/flag_icons/29.png
// module id = HLrN
// module chunks = 1